<template>
  <nav>
    <ul>
      <li>
        <button :disabled="$store.state.isDisabled" @click="addNewCard">
          <span :class="{ disabled: $store.state.isDisabled }"> Add Card</span>
        </button>
      </li>
      <li><header>GoalMaker</header></li>
      <dialog-dialog></dialog-dialog>
    </ul>
  </nav>
</template>
<script>
import DialogDialog from "../Settings/DialogWindow.vue";
export default {
  components: {
    DialogDialog,
  },
  methods: {
    addNewCard() {
      this.$store.commit("addNewCard");
    },
  },
};
</script>
<style lang="scss" scoped>
nav {
  background-color: darkslateblue;
  box-shadow: 0 0 1vh gray;
  border-bottom: 2px solid rgba(87, 179, 255, 0.356);
  ul {
    display: flex;
    justify-content: space-between;
    a {
      text-decoration: none;
    }
    li:nth-child(1) {
      cursor: default;
    }
    li:nth-child(2) {
      cursor: default;
      @media screen and (max-width: 350px) {
        display: none;
      }
    }
    button {
      height: auto;
      margin-left: 20px;
      background-color: transparent;
      border: none;
      outline: none;
      cursor: default;
      span {
        font-size: 20px;
        color: white;
        cursor: pointer;
        transition: color 0.18s ease-out;
        &:hover {
          color: darkgray;
          transition: color 0.18s ease-in;
        }
      }
    }
    li,
    a {
      color: white;
      font-size: 20px;
      padding: 18px 0px;
      cursor: pointer;
      transition: color 0.18s ease-out;
      &:hover {
        color: darkgray;
        transition: color 0.18s ease-in;
      }
      header {
        font-weight: bold;
      }
    }
    li {
      @media screen and (max-width: 450px) {
        font-size: 18px;
      }
    }
  }
}
.disabled {
  cursor: not-allowed;
}
</style>
